const Week = ({ children }) => {
    return (
        <div className="calendar__week">
            <div className="calendar__week-header">
                <div className="calendar__week-title">
                    <span>This</span>
                    <span style={{ color: "#8FC73E" }}>Week</span>
                </div>
            </div>
            {children}
        </div>
    );
};

export default Week;
